'use strict';

/**
 * Directive: Focus Inputs
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export focusMe for ES6 usage
 *          7.8.0 #513 Update Main Library for Job Override
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *         See: http://stackoverflow.com/questions/14833326/how-to-set-focus-on-input-field
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var focusMe = angular.module('wd.focus', [])
    .directive(
    'focusMe', function ()
    {
        return {
            link: function (scope, element, attrs)
            {
                scope.$watch(
                    attrs.focusMe, function (value)
                    {
                        if (value === true) {
                            //$timeout(function() {
                            element[0].focus();
                            scope[attrs.focusMe] = false;
                            //});
                        }
                    }
                );
            }
        };
    }
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = focusMe;
}    